import { TransferTemplate } from "model";

/**
* @class AddUnlinkedTransferAccountFormUI
* @classdesc Class definition for controlling what elements are rendered.
* @param {makeTransfer} _form - instance of the form which is used to create an unlinked account.
*/

//::constructor
export default class AddUnlinkedTransferAccountForm {
    _accountNickname;
    _accountOwnerType;
    _firstNameOfAccountOwner;
    _lastNameOfAccountOwner;
    _accountType;
    _accountNumber;
    _confirmAccountNumber;
   
    constructor(record) {
        this.accountNickname = record.accountNickname;
        this.accountOwnerType = record.accountOwnerType;
        this.firstNameOfAccountOwner = record.firstNameOfAccountOwner;
        this.lastNameOfAccountOwner = record.lastNameOfAccountOwner;
        this.accountType = record.accountType;
        this.accountNumber = record.accountNumber;
        this.confirmAccountNumber = record.confirmAccountNumber;
    }

    /** 
    * @name accountNickname
    * @instance
    * @property set {STRING} - set the account nickname
    * @memberof AddUnlinkedTransferAccountForm 
    */
    set accountNickname(value) {
        this._accountNickname = value;
    }

    /** 
    * @name accountOwnerType
    * @instance
    * @property set {STRING} - set the account owner type
    * @memberof AddUnlinkedTransferAccountForm 
    */
    set accountOwnerType(value) {
        this._accountOwnerType = value;
    }

    /** 
    * @name firstNameOfAccountOwner
    * @instance
    * @property set {STRING} - set the first name of the account owner
    * @memberof AddUnlinkedTransferAccountForm 
    */
    set firstNameOfAccountOwner(value) {
        this._firstNameOfAccountOwner = value;
    }

    /** 
    * @name lastNameOfAccountOwner
    * @instance
    * @property set {STRING} - set the last name of the account owner
    * @memberof AddUnlinkedTransferAccountForm 
    */
    set lastNameOfAccountOwner(value) {
        this._lastNameOfAccountOwner = value;
    }

    /** 
    * @name accountType
    * @instance
    * @property set {STRING} - set the account type
    * @memberof AddUnlinkedTransferAccountForm 
    */
    set accountType(value) {
        this._accountType = value;
    }

    /** 
    * @name accountNumber
    * @instance
    * @property set {STRING} - set the account number
    * @memberof AddUnlinkedTransferAccountForm 
    */
    set accountNumber(value) {
        this._accountNumber = value;
    }

    /** 
    * @name confirmAccountNumber
    * @instance
    * @property set {STRING} - set the confirmation of the account number
    * @memberof AddUnlinkedTransferAccountForm 
    */
    set confirmAccountNumber(value) {
        this._confirmAccountNumber = value;
    }

    /** 
    * @name accountNickname
    * @instance
    * @property get {STRING} - the account nickname
    * @memberof AddUnlinkedTransferAccountForm 
    */
    get accountNickname() {
        return this._accountNickname;
    }

    /** 
    * @name accountOwnerType
    * @instance
    * @property get {STRING} - the account owner type
    * @memberof AddUnlinkedTransferAccountForm 
    */
    get accountOwnerType() {
        return this._accountOwnerType;
    }

    /** 
    * @name firstNameOfAccountOwner
    * @instance
    * @property get {STRING} - the first name of the account owner
    * @memberof AddUnlinkedTransferAccountForm 
    */
    get firstNameOfAccountOwner() {
        return this._firstNameOfAccountOwner;
    }

    /** 
    * @name lastNameOfAccountOwner
    * @instance
    * @property get {STRING} - the last name of the account owner
    * @memberof AddUnlinkedTransferAccountForm 
    */
    get lastNameOfAccountOwner() {
        return this._lastNameOfAccountOwner;
    }

    /** 
    * @name accountType
    * @instance
    * @property get {STRING} - the account type
    * @memberof AddUnlinkedTransferAccountForm 
    */
    get accountType() {
        return this._accountType;
    }

    /** 
    * @name accountNumber
    * @instance
    * @property get {STRING} - the account number
    * @memberof AddUnlinkedTransferAccountForm 
    */
    get accountNumber() {
        return this._accountNumber;
    }

    /** 
    * @name confirmAccountNumber
    * @instance
    * @property get {STRING} - the confirmation of the account number
    * @memberof AddUnlinkedTransferAccountForm 
    */
    get confirmAccountNumber() {
        return this._confirmAccountNumber;
    }

    static defaultValues = {
        accountNickname: "",
        accountOwnerType: "Personal",
        firstNameOfAccountOwner: "",
        lastNameOfAccountOwner: "",
        accountType: "",
        accountNumber: "",
        confirmAccountNumber: ""
    };

    /**
     * 
     * @param {makeTransfer} form 
     * @returns this
     * static factory method for initializing  AddUnlinkedTransferAccountForm  
     */
    static init(record, branding) {
        const _record = record ?? {};
        const options = branding ? branding.options : {};
        const hasAccountOwnerTypeField = options.acctownertypedd_abi22 === "true";
        const values = {
            ...AddUnlinkedTransferAccountForm.defaultValues,
            accountOwnerType: hasAccountOwnerTypeField ? "Personal" : "",
            ..._record
        };
        return new AddUnlinkedTransferAccountForm(values);
    }
}